module.exports = __webpack_public_path__ + "assets/img/logo.68ab6ffa.png";